import {Routes} from '@angular/router';
import {AuthGuard} from '../core/security/auth-guard.service';
import {RolesEnum} from '../core/security/roles.enum';
import {ModulesEnum} from '../core/security/modules.enum';
import {MenuGroupEnum} from '../core/security/menu-group.enum';
import {UserLoginComponent} from './user-login/user-login.component';
import {HolidayGreetingsComponent} from './holiday-greetings/holiday-greetings.component';
import {HolidayGreetingsEditComponent} from './holiday-greetings-edit/holiday-greetings-edit.component';
import {PbxAccountsComponent} from './pbx-accounts/pbx-accounts.component';
import {EditPbxAccountComponent} from './pbx-accounts/edit/edit-pbx-account.component';
import { WallboardComponent } from './wallboard/wallboard.component';
import { PbxGroupsComponent } from './pbx-groups/pbx-groups.component';
import { EditPbxGroupComponent } from './pbx-groups/edit/edit-pbx-group.component';

export const routes: Routes = [
  {
    path: 'summary',
    component: UserLoginComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.PbxGroup,
      package: ModulesEnum.PbxModule,
      permissions: [RolesEnum.Pbx_View, RolesEnum.Pbx_Edit, RolesEnum.Pbx_Delete],
      animation: 'main',
      meta: {
        title: 'My Pbx',
        override: true,
        description: 'Login To PBX Console',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'cloud_circle',
        order: 4
      }
    }
  },
  {
    path: 'wallboard',
    component: WallboardComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.PbxGroup,
      package: ModulesEnum.PbxWallboardModule,
      permissions: [RolesEnum.PbxWallboardView, RolesEnum.PbxWallboardEdit, RolesEnum.PbxWallboardDelete],
      animation: 'main',
      meta: {
        title: 'Wallboard',
        override: true,
        description: 'Wallboard of PBX Agent Groups',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'dashboard',
        order: 1
      }
    }
  },
  {
    path: 'holiday-greetings',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: HolidayGreetingsComponent,
        canActivate: [AuthGuard],
        data: {
          menuGroup: MenuGroupEnum.PbxGroup,
          package: ModulesEnum.PbxHolidayGreetingsModule,
          permissions: [RolesEnum.PbxHolidayGreetings_View, RolesEnum.PbxHolidayGreetings_Edit, RolesEnum.PbxHolidayGreetings_Delete],
          meta: {
            title: 'Holiday Greetings',
            override: true,
            description: 'HolidayGreetings Page',
            inSideMenu: true,
            iconClass: 'material-icons',
            iconClassCode: 'event',
            order: 2
          }
        }
      },
      {
        path: ':account',
        component: HolidayGreetingsEditComponent,
        canActivate: [AuthGuard],
        data: {
          menuGroup: MenuGroupEnum.PbxGroup,
          package: ModulesEnum.PbxHolidayGreetingsModule,
          permissions: [RolesEnum.PbxHolidayGreetings_Edit, RolesEnum.PbxHolidayGreetings_Delete],
          meta: {
            title: 'Holiday Greetings',
            override: true,
            description: 'Holiday Greetings Edit Page',
            inSideMenu: false,
            iconClass: 'material-icons',
            iconClassCode: 'event',
          }
        }
      }
    ]
  },
  {
    path: 'extensions',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: PbxAccountsComponent,
        canActivate: [AuthGuard],
        data: {
          menuGroup: MenuGroupEnum.PbxGroup,
          package: ModulesEnum.PbxAccountsModule,
          permissions: [
            RolesEnum.PbxAccounts_View,
            RolesEnum.PbxAccounts_Edit,
            RolesEnum.PbxAccounts_EditOwn,
            RolesEnum.PbxAccounts_Delete,
          ],
          meta: {
            title: 'Extensions',
            override: true,
            description: 'Pbx Extensions Page',
            inSideMenu: true,
            iconClass: 'material-icons',
            iconClassCode: 'manage_accounts',
            order: 1
          }
        }
      },
      {
        path: ':id',
        component: EditPbxAccountComponent,
        canActivate: [AuthGuard],
        data: {
          menuGroup: MenuGroupEnum.PbxGroup,
          package: ModulesEnum.PbxAccountsModule,
          permissions: [RolesEnum.PbxAccounts_Edit, RolesEnum.PbxAccounts_EditOwn, RolesEnum.PbxAccounts_Delete],
          meta: {
            title: 'Extension Details',
            override: true,
            description: 'Pbx Extensions Edit Page',
            inSideMenu: false,
            iconClass: 'material-icons',
            iconClassCode: 'manage_accounts',
          }
        }
      }
    ]
  },
  {
    path: 'groups',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: PbxGroupsComponent,
        canActivate: [AuthGuard],
        data: {
          menuGroup: MenuGroupEnum.PbxGroup,
          package: ModulesEnum.PbxGroupsModule,
          permissions: [
            RolesEnum.PbxGroups_View,
            RolesEnum.PbxGroups_Edit,
            RolesEnum.PbxGroups_Delete,
          ],
          meta: {
            title: 'Groups',
            override: true,
            description: 'Pbx Groups Page',
            inSideMenu: true,
            iconClass: 'material-icons',
            iconClassCode: 'groups',
            order: 1
          }
        }
      },
      {
        path: ':id',
        component: EditPbxGroupComponent,
        canActivate: [AuthGuard],
        data: {
          menuGroup: MenuGroupEnum.PbxGroup,
          package: ModulesEnum.PbxGroupsModule,
          permissions: [RolesEnum.PbxGroups_Edit, RolesEnum.PbxGroups_Delete],
          meta: {
            title: 'Group Details',
            override: true,
            description: 'Pbx Group Edit Page',
            inSideMenu: false,
            iconClass: 'material-icons',
            iconClassCode: 'groups',
          }
        }
      }
    ]
  },
];
